import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebPage' | 'Service' | 'FAQPage' | 'JobPosting' | 'BlogPosting' | 'ContactPage';
  data: Record<string, unknown>;
}

export function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
}

export const organizationSchema = {
  name: 'おかやま保険株式会社',
  url: typeof window !== 'undefined' ? window.VITE_SITE_URL || 'https://example.com' : 'https://example.com',
  logo: typeof window !== 'undefined' ? `${window.VITE_SITE_URL || 'https://example.com'}/logo.png` : 'https://example.com/logo.png',
  description: '岡山市・倉敷市・総社市で3,000世帯以上の実績。生命保険・医療保険・自動車保険・火災保険など、あなたのライフステージに最適な保険プランをご提案。',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '○○町1-2-3',
    addressLocality: '岡山市北区',
    addressRegion: '岡山県',
    postalCode: '700-0000',
    addressCountry: 'JP',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.6617,
    longitude: 133.9350,
  },
  telephone: '+81-86-012-3456',
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    opens: '09:00',
    closes: '18:00',
  },
  founder: {
    '@type': 'Person',
    name: '岡山太郎',
  },
  foundingDate: '2020',
  numberOfEmployees: 3,
  areaServed: [
    {
      '@type': 'City',
      name: '岡山市',
    },
    {
      '@type': 'City',
      name: '倉敷市',
    },
    {
      '@type': 'City',
      name: '総社市',
    },
  ],
};
